export default class HandoverRegisterModel {
  HandoverRegisterId: number;
  SalesRegisterId: number;
  StatusId: number;
  Status: string;
  Remark: string;
  SalesNumber: string;
  CustomerName: string;
  MobileNumber: string;
  EmailId: string;
  PaymentMode: string;

  constructor() {
    this.HandoverRegisterId = 0;
    this.SalesRegisterId = 0;
    this.StatusId = 0;
    this.Status = '';
    this.Remark = '';
    this.SalesNumber = '';
    this.CustomerName = '';
    this.MobileNumber = '';
    this.EmailId = '';
    this.PaymentMode = '';
  }
}
